import { IconProps } from 'utils/types';

import { Icon } from '@project44/manifest-ui-deprecated';

const defaultSize = '24px'; // Matches Manifest Default
const defaultFill = ''; // Default to #000

export const AddIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon sx={sx} size={size} viewBox="0 0 14 14" data-testid="add-icon">
    <path
      clipRule="evenodd"
      d="M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z"
      fill={fill}
      fillRule="evenodd"
    />
  </Icon>
);

export const BoltIcon = () => (
  <Icon
    data-testid="bolt-icon"
    sx={{ width: 24, height: 24 }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.995 21h-1l1-7h-3.5c-.88 0-.33-.75-.31-.78 1.29-2.28 3.23-5.68 5.82-10.22h1l-1 7h3.51c.4 0 .62.19.4.66-3.95 6.89-5.92 10.34-5.92 10.34Z"
      fill="#6500CE"
    />
  </Icon>
);

export const BulbIcon = ({ fill = '#c7ccf0' }) => (
  <Icon
    data-testid="bulb-icon"
    sx={{ width: 24, height: 24 }}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.25 21h4c0 1.1-.9 2-2 2s-2-.9-2-2Zm-2-1h8v-2h-8v2Zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H4.52C3.41 16.36.75 14.32.75 10.5.75 6.36 4.11 3 8.25 3c4.14 0 7.5 3.36 7.5 7.5Zm-2 0c0-3.03-2.47-5.5-5.5-5.5a5.51 5.51 0 0 0-5.5 5.5c0 2.47 1.49 3.89 2.35 4.5h6.3c.86-.61 2.35-2.03 2.35-4.5Zm6.87-2.13L19.25 9l1.37.63.63 1.37.63-1.37L23.25 9l-1.37-.63L21.25 7l-.63 1.37ZM18.25 7l.94-2.06L21.25 4l-2.06-.94L18.25 1l-.94 2.06-2.06.94 2.06.94.94 2.06Z"
      fill={fill}
    />
  </Icon>
);

export const ChevronDownIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon sx={sx} size={size} viewBox="0 0 53 32" data-testid="chevrondown-icon">
    <path
      clipRule="evenodd"
      d="M1.396 1.421c-1.861 1.895-1.861 4.957 0 6.852l21.906 22.305c1.861 1.895 4.868 1.895 6.729 0l21.906-22.305c1.861-1.895 1.861-4.957 0-6.852s-4.868-1.895-6.729 0l-18.565 18.855-18.518-18.855c-1.861-1.895-4.916-1.847-6.729 0z"
      fill={fill}
      fillRule="evenodd"
    />
  </Icon>
);

export const CloseIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon sx={sx} size={size} viewBox="0 0 14 14" data-testid="close-icon">
    <path
      clipRule="evenodd"
      d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z"
      fill={fill}
      fillRule="evenodd"
    />
  </Icon>
);

export const CreateViewIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon size={size} data-testid="create-view-icon" viewBox="0 0 20 16" sx={sx}>
    <path
      d="m0 0v16h20v-16zm18 4.67h-2.5v-2.67h2.5zm-2.5 2h2.5v2.67h-2.5zm-13.5-4.67h11.5v12h-11.5zm13.5 12v-2.67h2.5v2.67z"
      fill={fill}
    />
  </Icon>
);

export const FilterIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon sx={sx} size={size} viewBox="0 0 18 12" data-testid="filter-icon">
    <path
      d="M8 12H10C10.55 12 11 11.55 11 11C11 10.45 10.55 10 10 10H8C7.45 10 7 10.45 7 11C7 11.55 7.45 12 8 12ZM0 1C0 1.55 0.45 2 1 2H17C17.55 2 18 1.55 18 1C18 0.45 17.55 0 17 0H1C0.45 0 0 0.45 0 1ZM4 7H14C14.55 7 15 6.55 15 6C15 5.45 14.55 5 14 5H4C3.45 5 3 5.45 3 6C3 6.55 3.45 7 4 7Z"
      fill={fill}
      fillOpacity="0.9"
    />
  </Icon>
);

export const RevertIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon size={size} data-testid="revert-icon" viewBox="0 0 22 16" sx={sx}>
    <path
      d="m18 4-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46c1.23.78 2.69 1.24 4.26 1.24 4.42 0 8-3.58 8-8h3zm-13 4c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46c-1.23-.78-2.69-1.24-4.26-1.24-4.42 0-8 3.58-8 8h-3l4 4 4-4z"
      fill={fill}
    />
  </Icon>
);

export const SearchIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx = {},
}: IconProps) => (
  <Icon sx={sx} viewBox="0 0 14 14" size={size} data-testid="search-icon">
    <path
      d="M9.62498 8.49998H9.03248L8.82248 8.29748C9.72248 7.24748 10.1875 5.81498 9.93248 4.29248C9.57998 2.20748 7.83998 0.542481 5.73998 0.287481C2.56748 -0.102519 -0.102519 2.56748 0.287481 5.73998C0.542481 7.83998 2.20748 9.57998 4.29248 9.93248C5.81498 10.1875 7.24748 9.72248 8.29748 8.82248L8.49998 9.03248V9.62498L11.6875 12.8125C11.995 13.12 12.4975 13.12 12.805 12.8125C13.1125 12.505 13.1125 12.0025 12.805 11.695L9.62498 8.49998ZM5.12498 8.49998C3.25748 8.49998 1.74998 6.99248 1.74998 5.12498C1.74998 3.25748 3.25748 1.74998 5.12498 1.74998C6.99248 1.74998 8.49998 3.25748 8.49998 5.12498C8.49998 6.99248 6.99248 8.49998 5.12498 8.49998Z"
      fill={fill}
      fillOpacity="0.42"
    />
  </Icon>
);

export const TrashIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx = {},
}: IconProps) => (
  <Icon sx={sx} viewBox="0 0 14 18" size={size} data-testid="trash-icon">
    <path
      d="M1 16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4H1V16ZM3 6H11V16H3V6ZM10.5 1L9.5 0H4.5L3.5 1H0V3H14V1H10.5Z"
      fill={fill}
    />
  </Icon>
);

export const UpdateIcon = ({
  fill = defaultFill,
  size = defaultSize,
  sx,
}: IconProps) => (
  <Icon size={size} data-testid="update-icon" viewBox="0 0 18 18" sx={sx}>
    <path
      d="m8 5v5l4.25 2.52.77-1.28-3.52-2.09v-4.15zm10 2v-7l-2.64 2.64c-1.62-1.63-3.87-2.64-6.36-2.64-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9h-2c0 3.86-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7c1.93 0 3.68.79 4.95 2.05l-2.95 2.95z"
      fill={fill}
    />
  </Icon>
);

export const ExportHeaderIcon = ({
  sx,
  fill = '#1F3987',
}: Omit<IconProps, 'size'>) => {
  return (
    <Icon
      data-testid="export-header-icon"
      sx={{ width: 32, height: 37, ...sx }}
      viewBox="0 0 32 37"
      fill="none"
    >
      <path
        d="M30.8402 26.5355L32 24.1071V12.5301L30.8295 10.0953L17.856 0H13.9287L1.14278 10.1059L0 12.5194V24.1178L1.15131 26.5377L13.9202 36.6223L17.8453 36.6436L30.8402 26.5355ZM1.98068 11.1485L14.773 1.04897C14.9085 0.940576 15.0594 0.852916 15.2207 0.78886V12.7284C14.9713 12.7923 11.2871 15.6919 10.3767 16.4168L11.4427 17.2846L15.2804 14.1824H16.4957L20.3867 17.2696L21.4677 16.3976C20.7982 15.8795 16.8091 12.7966 16.5639 12.7198V0.780332C16.7337 0.845468 16.8926 0.93605 17.0351 1.04897L30.0108 11.1442C30.03 11.1613 30.0428 11.1784 30.062 11.1954L20.3867 18.9945L20.1543 19.1885L16.4978 22.1307H15.2826L12.0205 19.4529L11.8819 19.3399L8.27877 16.3891L1.93591 11.1954L1.98068 11.1485ZM14.7581 35.5797L1.99134 25.4972C1.90595 25.4221 1.82615 25.3409 1.75255 25.2542L8.38537 19.8473L7.30229 18.9753L1.33253 23.8662V12.5194C1.33253 12.4938 1.33253 12.4683 1.33253 12.4427C1.33253 12.4171 4.2172 14.7751 7.34493 17.3059C8.79686 18.4785 10.3021 19.6938 11.609 20.7385C13.6089 22.3418 15.1291 23.5464 15.2207 23.5741V35.8484C15.0543 35.7817 14.8984 35.6913 14.7581 35.5797ZM16.5533 23.5805C16.6577 23.5507 18.6299 22.0028 21.069 20.0712C22.4313 18.9902 23.943 17.7877 25.3523 16.6599C28.2071 14.385 30.6504 12.4277 30.6504 12.4277C30.6504 12.4277 30.6611 12.4917 30.6611 12.5258V23.879L24.5613 18.954L23.4952 19.8068L30.2347 25.2457C30.1665 25.3298 30.0909 25.4076 30.0087 25.478L17.0159 35.6053C16.8765 35.7166 16.7204 35.8051 16.5533 35.8675V23.5805Z"
        fill={fill}
      />
    </Icon>
  );
};

export const ExportFailureIcon = ({
  sx,
  fill = '#F45E1E',
}: Omit<IconProps, 'size'>) => {
  return (
    <Icon
      data-testid="export-failure-icon"
      sx={{ width: 64, height: 64, ...sx }}
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM32 18.9996V22.878C32 23.853 33.17 24.3296 33.8417 23.6363L39.8867 17.5913C40.32 17.158 40.32 16.4863 39.8867 16.053L33.8417 10.008C33.17 9.3363 32 9.81297 32 10.788V14.6663C22.4233 14.6663 14.6667 22.423 14.6667 31.9996C14.6667 34.253 15.1 36.4196 15.9017 38.3913C16.4867 39.843 18.35 40.233 19.455 39.128C20.04 38.543 20.2783 37.6546 19.9533 36.8746C19.325 35.3796 19 33.7113 19 31.9996C19 24.828 24.8283 18.9996 32 18.9996ZM44.545 24.8713C43.96 25.4563 43.7217 26.3663 44.0467 27.1246C44.6533 28.6413 45 30.288 45 31.9996C45 39.1713 39.1717 44.9996 32 44.9996V41.1213C32 40.1463 30.83 39.6696 30.1583 40.363L24.1133 46.408C23.68 46.8413 23.68 47.513 24.1133 47.9463L30.1583 53.9913C30.83 54.663 32 54.1863 32 53.233V49.333C41.5767 49.333 49.3333 41.5763 49.3333 31.9996C49.3333 29.7463 48.9 27.5796 48.0983 25.608C47.5133 24.1563 45.65 23.7663 44.545 24.8713Z"
        fill={fill}
      />
    </Icon>
  );
};

export const ExportSuccessfulIcon = ({
  sx,
  fill = '#16158D',
}: Omit<IconProps, 'size'>) => {
  return (
    <Icon
      data-testid="export-success-icon"
      sx={{ width: 64, height: 64, ...sx }}
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM16.704 32L25.6 40.896L48.192 18.3253L51.2 21.3333L25.6 46.9333L13.6747 35.008L16.704 32Z"
        fill={fill}
      />
    </Icon>
  );
};

export const ExportLoadingIcon = ({
  sx,
  fill = '#16158D',
}: Omit<IconProps, 'size'>) => {
  return (
    <Icon
      data-testid="export-loading-icon"
      sx={{ width: 64, height: 64, ...sx }}
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM16 44.8C16 46.56 17.44 48 19.2 48C20.96 48 22.4 46.56 22.4 44.8V28.8C22.4 27.04 20.96 25.6 19.2 25.6C17.44 25.6 16 27.04 16 28.8V44.8ZM32 48C30.24 48 28.8 46.56 28.8 44.8V19.2C28.8 17.44 30.24 16 32 16C33.76 16 35.2 17.44 35.2 19.2V44.8C35.2 46.56 33.76 48 32 48ZM41.6 44.8C41.6 46.56 43.04 48 44.8 48C46.56 48 48 46.56 48 44.8V38.4C48 36.64 46.56 35.2 44.8 35.2C43.04 35.2 41.6 36.64 41.6 38.4V44.8Z"
        fill={fill}
      />
    </Icon>
  );
};

export const WifiUnknownIcon = () => (
  <Icon
    data-testid="wifi-question-icon"
    viewBox="0 0 20 20"
    sx={{ backgroundColor: 'white', width: 20, height: 20, borderRadius: 10 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm3.692 8.335c-1.274 0-2.307 1.073-2.307 2.396 0 .594.216 1.135.563 1.552l-1.228 1.591a.901.901 0 0 1-1.44 0L4.194 7.29l.036-.028C4.596 6.969 6.783 5.22 10 5.22c3.217 0 5.404 1.75 5.77 2.042l.036.028-1.034 1.337a2.189 2.189 0 0 0-1.08-.292zm-.438 5.534h.877v.91h-.877zm-1.09-3.69c.222-.656.822-1.125 1.528-1.125.891 0 1.616.752 1.616 1.686 0 .336-.125.666-.347.91-.106.12-.216.235-.327.35l-.049.052a2.283 2.283 0 0 0-.311.385 1.287 1.287 0 0 0-.157.464.408.408 0 0 1-.402.35c-.254 0-.447-.24-.406-.498a.248.248 0 0 0 .005-.027 1.696 1.696 0 0 1 .319-.73c.09-.118.202-.23.316-.343.315-.313.639-.634.523-1.124a.816.816 0 0 0-.881-.632.821.821 0 0 0-.665.565.401.401 0 0 1-.378.269.417.417 0 0 1-.383-.551z"
      fill="rgb(46, 57, 173)"
    />
  </Icon>
);

export const ChatIcon = ({ fill = '#6500CE', size = '24px' }: IconProps) => (
  <Icon data-testid="bulb-icon" size={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
      fill={fill}
    />
    <path
      d="M12 15L13.57 11.57L17 10L13.57 8.43L12 5L10.43 8.43L7 10L10.43 11.57L12 15Z"
      fill={fill}
    />
  </Icon>
);

export const ThumbUpIcon = ({ size = '16px' }: IconProps) => (
  <Icon data-testid="thumb-up-icon" size={size} viewBox="0 0 16 16" fill="none">
    <path
      fill="#898E94"
      d="M14.001 6H9.795l.633-3.047.02-.213c0-.274-.113-.527-.293-.707l-.707-.7-4.387 4.393c-.246.24-.393.574-.393.94v6.667c0 .733.6 1.333 1.333 1.333h6c.554 0 1.027-.333 1.227-.813l2.013-4.7c.06-.153.094-.313.094-.487V7.333C15.335 6.6 14.735 6 14 6Zm0 2.666-2 4.667h-6V6.666l2.894-2.893-.74 3.56H14v1.333Zm-13.333-2h2.667v8H.668v-8Z"
    />
  </Icon>
);

export const ThumbDownIcon = ({ size = '16px' }: IconProps) => (
  <Icon
    data-testid="thumb-down-icon"
    size={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill="#898E94"
      d="M10.001 1.333h-6c-.553 0-1.026.333-1.226.813L.76 6.846c-.06.154-.093.314-.093.487v1.333c0 .734.6 1.334 1.333 1.334h4.207l-.633 3.046-.02.214c0 .273.113.526.293.706l.707.7 4.386-4.393c.247-.24.394-.573.394-.94V2.666c0-.733-.6-1.333-1.334-1.333Zm0 8-2.893 2.893.74-3.56H2.001V7.333l2-4.667h6v6.667Zm2.667-8h2.667v8h-2.667v-8Z"
    />
  </Icon>
);

export const EllipsisIcon = ({ size = '24px' }) => (
  <Icon
    data-testid="ellipsis-icon"
    width={size}
    viewBox="0 0 24 12"
    fill="none"
    sx={{ verticalAlign: 'bottom' }}
  >
    <circle cx="6" cy="6" r="2">
      <animate
        attributeName="fill"
        values="white;697078;697078;697078;white"
        dur="3s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="12" cy="6" r="2">
      <animate
        attributeName="fill"
        values="697078;white;697078;697078;697078"
        dur="3s"
        repeatCount="indefinite"
      />
    </circle>
    <circle cx="18" cy="6" r="2">
      <animate
        attributeName="fill"
        values="697078;697078;white;697078;697078"
        dur="3s"
        repeatCount="indefinite"
      />
    </circle>
  </Icon>
);
